import { observer } from "mobx-react-lite";

import { ExportApplicationButton, toExportItemsFromTable } from "../../../components/export-application";
import { useClientType } from "../../../shared/hooks/use-client-type";
import { usePageStore } from "../applications-page.lib";

export const ApplicationsExportButton = observer(() => {
  const pageStore = usePageStore();
  const clientType = useClientType();
  const selectedApplications = pageStore?.selectedApplications ?? [];

  return (
    <ExportApplicationButton
      applications={toExportItemsFromTable(selectedApplications, clientType)}
      disabled={clientType === "external" && selectedApplications.length === 0}
      onExported={async () => {
        pageStore?.tableApi?.refreshInfiniteCache();
        pageStore?.tableApi?.deselectAll();
      }}
    />
  );
});
